import { ApiStatus, FETCH_METHODS, SearchConfig } from "../api.model"
import { BUTTON_NAMES } from "../common.model";
import { DataTableSchema, TableColumnSchema } from "../dynamic-data-table.model"
import { AdjustedTenureNumber, Attachment, BrandDropdown, BrandTenureText, BrandText, commentsText, defaultSearchContainerButtons, DefaultTenure, EmpStatusDropdown, FieldNames, FirstNameText, LastNameText, SpinIdNumber } from "../form-fields.model";
import { ButtonFieldConfig, DynamicFormArray, FormFieldConfig, Props } from "../form.model"
import { TenureAreaOptions, tenureAreaRegionField, TenureDefaultTableSchema, TenureTitle } from "../tenure.model";

export const BrandTenureTitle = 'Brand Tenure'
export const BrandTenureEdit = 'brand_tenure_edit'
export const BrandTenureHistory = 'brand_tenure_history'
export const brandTenureEditTitle = "Adjustment For Brand Tenure";
export const BrandTenureChange = "brand_tenure_change"
export const BrandTenure ="Brand Tenure"
const BrandTenureFilterField: FormFieldConfig = {
  ...structuredClone(DefaultTenure),
  fieldName: FieldNames['Tenure'],
  displayName: BrandTenure,
  fieldCriteriaConfig: {
    operators: [
      { value: 'less than', label: 'Less than', title: 'Less Than' },
      { value: 'greater than', label: 'Greater than', title: 'Greater Than' },
      { value: 'equal to', label: 'Equal to', title: 'Equal to' }
    ],
    value: 'equal to'
  }
}
const FormFieldArray: FormFieldConfig[] = structuredClone([
  SpinIdNumber, BrandDropdown,
  {...structuredClone(tenureAreaRegionField),multiple:true, options:TenureAreaOptions},
  FirstNameText, LastNameText, EmpStatusDropdown, BrandTenureFilterField
]);

const ForUpdateFormFieldArray: FormFieldConfig[] = structuredClone([
  SpinIdNumber,BrandText, BrandTenureText,
  {...structuredClone(AdjustedTenureNumber), pattern: String.raw`^(?:[1-9][0-9]*)$`},
  commentsText,
  {...structuredClone(Attachment), multiple:true}
]);

const FormButtonArray: ButtonFieldConfig[] = structuredClone(defaultSearchContainerButtons);

const columnSchema: Array<TableColumnSchema> = [
  {
    label: 'Actions', fieldKey: 'brand_tenure_actions', fieldType: 'Actions', actionConfig: [
    //   {
    //   fieldKey: BrandTenureEdit,
    //   iconClass: 'fa-solid fa-pen',
    //   toolTip: 'Edit'
    // },
     {
      fieldKey: BrandTenureHistory,
      iconClass: 'fa-solid fa-clock-rotate-left',
      toolTip: 'History'
    }, {
      fieldKey: BrandTenureChange,
      iconClass: 'fa-solid fa-flag-checkered',
      toolTip: 'Info',
      color:'#00f',
      dependentFieldName: 'historyFlag',      
      isCustomToolTip:true
    }]
  },
  { label: "SPIN ID", fieldKey: 'spinId' },
  { label: "FIRST NAME", fieldKey: 'firstName' },
  { label: "LAST NAME", fieldKey: 'lastName' },
  { label: "EMAIL", fieldKey: 'email' },
  // { label: "IS PRIMARY", fieldKey: 'isPrimary' },
  { label: "EMPLOYEE STATUS", fieldKey: 'employeeStatus' },
  { label: "Brand", fieldKey: 'brand' },
  { label: "Actual Brand Tenure", fieldKey: 'actualTenureOverall' },
  { label: "Adjusted Brand Tenure", fieldKey: 'adjustedTenureOverall' , isCamelCaseHeader: true },
  { label: "Total Tenure", fieldKey: 'brandTenure' , isCamelCaseHeader: true }
]

export const BrandTenureSearchConfig: SearchConfig = {
  method: FETCH_METHODS['Post'],
  path: "getBrandTenure",
  body: {
    "spinId": "",
    "area": "",
    "firstName": "",
    "lastName": "",
    "employeeStatus": "",
    "brand": "",
    "tenureCondition": "",
    "tenure": "",
    "type": "BRAND"
  }
}


export const BrandTenureHistorySearchConfig:SearchConfig = {
  method: "POST",
  path: "getTenureHistory",
  body:{
    [FieldNames['SpinId']]: '',
    brand: '',
    "type": "brand"
  }
}
export const BrandTenureUpdateSearchConfig: SearchConfig = {
  method: FETCH_METHODS['Post'],
  path: "updateTenure",
  body: {
    "spinId": "",
    "adjustedTenure": "",
    "updatedBy":"",
    "updatedByName": '',
    "comments": "",
    "isOem":true,
    "type": "brand"
  }
}
export const ValidateExportApiSearchConfig: SearchConfig = {
  method: "POST",
  path: "getExportData",
  body:{
    fileName:''
  }
}

export const BrandEditileExportSearchConfig:SearchConfig = {
    method:FETCH_METHODS['Post'],
    path:'getSignedUrl',
    body:{
        bucketName:'',
        key: '',
        type: 'Download'
    }
}

export const BrandTenureAttchmentSearchConfig: SearchConfig = {
  method: FETCH_METHODS['Post'],
  path: "tenureUpload",
  body:{
    [FieldNames['Attachment']]: '',
    [FieldNames['SpinId']]: '',
    type: 'brand',
    tenureId: ''
  },
  headers:{}
}


export const BrandTenureFilterSchema: DynamicFormArray = {
  FieldsArray: FormFieldArray,
  ButtonsArray: FormButtonArray,
  searchConfig: BrandTenureSearchConfig,
}

export const EditActionButtons: ButtonFieldConfig[] = [
    { isDisabled: false, name: BUTTON_NAMES.Update },
    { isDisabled: false, name: BUTTON_NAMES.Cancel }
]
export const BrandTenureEditFilterSchema: DynamicFormArray = {
    FieldsArray: ForUpdateFormFieldArray,
    ButtonsArray: FormButtonArray,
    searchConfig: BrandTenureUpdateSearchConfig,
    title: brandTenureEditTitle,
    resetAfterSubmit: true,
    isCloseIcon:true
}
export const EditActionFieldSchema: DynamicFormArray = {
    ...structuredClone(BrandTenureEditFilterSchema),
    ButtonsArray: EditActionButtons,
}

export const BrandTenureTableSchema: DataTableSchema = {
  ...structuredClone(TenureDefaultTableSchema),
  columnSchema: columnSchema,
  toolTip:[
    {isStatic:true, msg: 'Tenure has been adjusted for this Spin ID. Please refer history for additional details'}
  ],
  exportConfig:{
    fileName: 'brand_tenure',
    exportMessage:'Brand Tenure data',
    schema: {
      spinId: "Spin ID",
      firstName: "Fisrt Name",
      lastName: "Last Name",
      email: "Email",
      employeeStatus: "Employee Status",
      brand: "Brand",
      brandTenure: BrandTenure
    }
  },
  breadcrums: [{ level: 1, name: TenureTitle }, { level: 2, name: BrandTenureTitle }]
}
export const note: Array<any> = [
    'Tenure displayed in Months'
]

export const BrandTenureProps: Props = {
  isBreadCrumbSection: true,
  optionExplanation: note,
}

export type successFailureMsg = Record<ApiStatus, string>
